(function Remote(window) {

  function stringToNode(htmlString) {
    var div = document.createElement('div');
    var scriptEl;
    div.innerHTML = htmlString.trim();

    // div.firstChild trick doesn't work for <script> elements
    // script has to be created strictly using document.createElement
    if (div.firstChild && div.firstChild.tagName === 'SCRIPT') {
      scriptEl = document.createElement('script');
      scriptEl.src = div.firstChild.src;
      scriptEl.async = div.firstChild.async;
      return scriptEl;
    }
    if (div.firstChild) {
      return div.firstChild;
    }

    return null;
  }
  function injectStyles(styles) {
    var styleNodes = document.querySelectorAll('style');
    var existingStyles = [];
    Array.prototype.slice.call(styleNodes).map(function (n) {
      existingStyles.push(n.innerText);
    });

    styles.map(function (s) {
      if (existingStyles.indexOf(s.innerText) === -1) {
        document.head.appendChild(s);
      }
    });
  }

  function injectLinks(links) {
    var linkNodes = document.querySelectorAll('link');
    var existingLinks = [];
    Array.prototype.slice.call(linkNodes).map(function (n) {
      existingLinks.push(n.href);
    });

    links.map(function (l) {
      if (existingLinks.indexOf(l.href) === -1) {
        document.head.appendChild(l);
      }
    });
  }

  function injectScripts(scripts) {
    var scriptNodes = document.querySelectorAll('script');
    var existingScripts = [];
    var existingInlineScripts = [];
    Array.prototype.slice.call(scriptNodes).map(function (n) {
      if (n.src) {
        existingScripts.push(n.src);
      } else {
        existingInlineScripts.push(n.innerText);
      }
    });

    scripts.map(function (s) {
      if (s.src) {
        if (existingScripts.indexOf(s.src) === -1) {
          document.body.appendChild(s);
        }
      }
      if (s.innerText) {
        if (existingInlineScripts.indexOf(s.innerText) === -1) {
          document.body.appendChild(s);
        }
      }
    });
  }

  function buildAssetsMap(headAppends, bodyAppends) {
    var assets = {
      styles: [],
      links: [],
      scripts: [],
    };

    var i;
    // simple naive assets parsing
    for (i = 0; i < headAppends.length; i += 1) {
      if (headAppends[i].substring(0, 6) === '<style') {
        assets.styles.push(stringToNode(headAppends[i]));
      } else if (headAppends[i].substring(0, 7) === '<script') {
        assets.scripts.push(stringToNode(headAppends[i]));
      } else if (headAppends[i].substring(0, 5) === '<link') {
        assets.links.push(stringToNode(headAppends[i]));
      }
    }

    for (i = 0; i < bodyAppends.length; i += 1) {
      if (bodyAppends[i].substring(0, 7) === '<script') {
        assets.scripts.push(stringToNode(bodyAppends[i]));
      }
    }
    return assets;
  }

  function evaluateFallbackIfAvailable(config) {
    var fallbackConfig;
    if (config.fallback) {
      fallbackConfig = config.fallback;
      fallbackConfig.id = config.id;
      // eslint-disable-next-line no-use-before-define
      evaluateAsync(fallbackConfig);
    }
  }

  function evaluateAsync(config) {
    var id = config.id;
    var url = config.fetch;
    var assets;
    var xhr;
    var jsonResponse;

    var el = document.querySelector('.js-tc_remote[data-remote-id="' + id + '"]');
    if (!el) {
      return;
    }

    el.classList.add('tc_remote--loading');

    xhr = new XMLHttpRequest();
    xhr.onload = function _load() {
      if (this.status === 200) {
        try {
          jsonResponse = JSON.parse(xhr.responseText); // fix for IE, it doesn't support JSON response type
        } catch (e) {
          evaluateFallbackIfAvailable(config);
        }
        assets = buildAssetsMap(jsonResponse.headAppend, jsonResponse.bodyAppend);
        injectStyles(assets.styles);
        injectScripts(assets.scripts);
        injectLinks(assets.links);

        try {
          el.parentNode.replaceChild(stringToNode(jsonResponse.body), el);
        } catch (e) {
          if (typeof window !== 'undefined' && window && window.TrackJS) {
            window.TrackJS.addMetadata('remote_vanilla_error', e);
            window.TrackJS.addMetadata('remote_vanilla_error_element', el);
            window.TrackJS.addMetadata('component_error_type', 'ExceptionError');
            window.TrackJS.console.error('component_error', { e, el });
            window.TrackJS.removeMetadata('remote_vanilla_error');
            window.TrackJS.removeMetadata('remote_vanilla_error_element');
            window.TrackJS.removeMetadata('component_error_type');
          }
        }
      } else {
        evaluateFallbackIfAvailable(config);
      }
    };
    xhr.ontimeout = function () {
      el.classList.remove('tc_remote--loading');
      el.classList.add('tc_remote--timed-out');
    };

    xhr.open('GET', url);
    xhr.send();
  }


  function initRemoteElements() {
    var configs = window.asyncComponents;
    var i;
    for (i = 0; i < configs.length; i += 1) {
      evaluateAsync(configs[i]);
    }
  }

  function domready() {
    try {
      initRemoteElements();
    } catch (error) {
      if (window.TrackJS) {
        window.TrackJS.console.error('Failed to load remote elements', { error });
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', domready);
  } else {
    domready();
  }
}(window));
